import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogClickSignInByEmail = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(() => {
    logAnalyticsEvent({ name: 'CLICK_SIGN_IN_BY_EMAIL' });
  }, [logAnalyticsEvent]);
};
